class ThumbnailNavigation extends HTMLElement {
  constructor() {
    super();
    this.thumbnailList = this.querySelector('.thumbnail-list');
    this.upButton = this.querySelector('.thumbnail-nav--up');
    this.downButton = this.querySelector('.thumbnail-nav--down');
    this.scrollStep = 100; // Adjust this value as needed
    
    this.init();
  }

  init() {
    if (!this.thumbnailList || !this.upButton || !this.downButton) return;
    
    // Set initial button states
    this.updateButtonVisibility();
    
    // Add event listeners
    this.upButton.addEventListener('click', () => this.scroll('up'));
    this.downButton.addEventListener('click', () => this.scroll('down'));
    this.thumbnailList.addEventListener('transitionend', () => this.updateButtonVisibility());
    
    // Update button visibility on resize
    window.addEventListener('resize', () => this.updateButtonVisibility());
  }

  scroll(direction) {
    const currentTransform = this.getCurrentTransform();
    const maxScroll = this.thumbnailList.scrollHeight - this.thumbnailList.clientHeight;
    
    let newTransform;
    if (direction === 'up') {
      newTransform = Math.min(0, currentTransform + this.scrollStep);
    } else {
      newTransform = Math.max(-maxScroll, currentTransform - this.scrollStep);
    }
    
    this.thumbnailList.style.transform = `translateY(${newTransform}px)`;
    this.updateButtonVisibility();
  }

  getCurrentTransform() {
    const transform = window.getComputedStyle(this.thumbnailList).transform;
    if (transform === 'none') return 0;
    
    const matrix = new DOMMatrix(transform);
    return matrix.m42; // Y transform value
  }

  updateButtonVisibility() {
    const currentTransform = this.getCurrentTransform();
    const maxScroll = this.thumbnailList.scrollHeight - this.thumbnailList.clientHeight;
    
    // Show/hide up button
    this.upButton.classList.toggle('hidden', currentTransform >= 0);
    
    // Show/hide down button
    this.downButton.classList.toggle('hidden', currentTransform <= -maxScroll || maxScroll <= 0);
  }
}

customElements.define('thumbnail-navigation', ThumbnailNavigation); 